import { YourSituationQuestion } from './YourSituationQuestion';

export { YourSituationQuestion } from './YourSituationQuestion';
export default YourSituationQuestion;
